import { DismissalSchedule } from '@shared/utils/dismissal-schedule/dismissal-schedule.interface';
// TISS-7648: the ui-state backend is not in the release. Uncomment together with the ui-state block below.
// import { UserAnnouncementStatus } from '@shared/enums/user-announcement-status.enum';
// import { UpdateUserAnnouncementRequest } from '@shared/interfaces/users/update-user-announcement-request.interface';

// v2 is the balance top-up announcement: a new prefix starts the shows over for users who closed the launch one.
const STORAGE_KEY_PREFIX = 'online-payment-announcement-v2';

// News article the announcement links to: the launch article, updated in place for the balance top-up.
export const ONLINE_PAYMENT_NEWS_ID = 'a9b278e0-f040-4ce3-a1bf-2d5af3a306f2';

export const ONLINE_PAYMENT_ANNOUNCEMENT_DIALOG_WIDTH = '498px';

export const ONLINE_PAYMENT_ANNOUNCEMENT_DIALOG_CLASS = 'online-payment-announcement-dialog';

// Horizontally the illustration may run into the panel padding on narrow phones, so only the vertical overflow scrolls.
export const ONLINE_PAYMENT_ANNOUNCEMENT_CONTENT_STYLE = { overflowX: 'hidden', overflowY: 'auto' };

// The announcement text names the dialog for screen readers.
export const ONLINE_PAYMENT_ANNOUNCEMENT_MESSAGE_ID = 'online-payment-announcement-message';

// Shown twice: on the first login after the release and again a week after the first close.
export const ONLINE_PAYMENT_ANNOUNCEMENT_SCHEDULE: DismissalSchedule = {
  repeatAfterDays: 7,
  maxDismissals: 2,
};

export function getOnlinePaymentAnnouncementStorageKey(userId: string): string {
  return `${STORAGE_KEY_PREFIX}:${userId}`;
}

// TISS-7648: the ui-state backend is not in the release. Once it ships, the backend owns availability again:
// uncomment this block and the ui-state block in OnlinePaymentAnnouncementDialogService, drop the schedule above.
//
// export const ONLINE_PAYMENT_ANNOUNCEMENT_KEY = 'announcement-online-payment-announcement-v2';
//
// // The backend owns availability; the first close defers the next show by exactly seven UTC days.
// export const ONLINE_PAYMENT_ANNOUNCEMENT_REPEAT_MS = 7 * 24 * 60 * 60 * 1000;
// export const ONLINE_PAYMENT_ANNOUNCEMENT_LEGACY_MAX_DISMISSALS = 2;
//
// /** Body of the show result: Deferred waits a week from `deferredFrom`, any other status has no date. */
// export function getOnlinePaymentAnnouncementRequest(status: UserAnnouncementStatus, deferredFrom: number): UpdateUserAnnouncementRequest {
//   return {
//     status,
//     showAfter:
//       status === UserAnnouncementStatus.Deferred ? new Date(deferredFrom + ONLINE_PAYMENT_ANNOUNCEMENT_REPEAT_MS).toISOString() : null,
//   };
// }

// Figma exports the illustration at 346×184; the asset is @2x.
export const ONLINE_PAYMENT_ANNOUNCEMENT_ILLUSTRATION = {
  src: 'assets/images/online-payment-announcement/illustration.webp',
  width: 346,
  height: 184,
};
